"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.wrapRootElement = void 0;
var _react = _interopRequireDefault(require("react"));
var _constants = require("./constants");
var _BreakpointProvider = require("./BreakpointProvider");
// eslint-disable-next-line no-unused-vars

const wrapRootElement = ({
  element
}, {
  queries = null
}) => {
  return /*#__PURE__*/_react.default.createElement(_BreakpointProvider.BreakpointProvider, {
    queries: queries !== null ? queries : _constants.defaultQueries
  }, element);
};
exports.wrapRootElement = wrapRootElement;